export const firmwareBySerial = (
  deviceModel: string,
  serialNumber: string
): string => `/models/${deviceModel}/devices/${serialNumber}/firmware`;
